module.exports = __webpack_public_path__ + "img/cuba_libre.9855f104.jpg";